import { useEffect, useMemo } from 'react'
import { Summary } from '../../../../types'
import { useStorePlayer } from '../store'
import { useUpgradabilityNotificationsV2 } from '../../../../hooks/tasks/use-upgradability-new/use-upgradability-notifications-new'

interface Props {
  summary?: Summary
}

export const useDataStatusUpgradability = ({ summary }: Props): void => {
  const { setData } = useStorePlayer()

  useUpgradabilityNotificationsV2({
    summary
  })

  const status = useMemo<
    'update' | 'processing' | 'failed' | 'succeeded'
  >(() => {
    const separate = summary?.separate

    if (separate?.status === 'FAILED') {
      return 'failed'
    }

    if (separate?.updateInProgress) {
      return 'update'
    }

    if (
      separate?.updateType === 'CHANGE' ||
      (separate?.status && ['QUEUED', 'STARTED'].includes(separate?.status))
    ) {
      return 'processing'
    }

    return 'succeeded'
  }, [summary])

  useEffect(() => {
    setData({
      status
    })
  }, [status, setData])
}
